package team.platforma.multiplatform_material_extension.fab.style

import androidx.compose.material3.ButtonDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.unit.dp
import team.platforma.multiplatform_material_extension.button.style.AppButtonStyle

object AppFabStyle {
    private var mButton : AppButtonStyle.Button = AppButtonStyle.Button()

    @Composable
    fun define(
        button: AppButtonStyle.Button = AppButtonStyle.Button(
            elevation = ButtonDefaults.buttonElevation(
                defaultElevation = 2.dp,
                pressedElevation = 0.dp,
                focusedElevation = 2.dp,
                hoveredElevation = 2.dp,
                disabledElevation = 0.dp
            )
        ),
    ) {
        mButton = button
    }

    @Composable
    fun fabButton(): AppButtonStyle.FilledButton {
        return AppButtonStyle.FilledButton(
            shape = mButton.shape ?: AppButtonStyle.filledButton().shape,
            colors = mButton.colors ?: AppButtonStyle.filledButton().colors,
            elevation = mButton.elevation ?: ButtonDefaults.buttonElevation(
                defaultElevation = 2.dp,
                pressedElevation = 0.dp,
                focusedElevation = 2.dp,
                hoveredElevation = 2.dp,
                disabledElevation = 0.dp
            ),
            border = mButton.border ?: AppButtonStyle.filledButton().border
        )
    }
}